import auto from './auto';
import history from './history';
import open from './open';

export default {
  auto,
  history,
  open,
};
